import React, { useEffect, useState } from "react";
import { URLdecode, URLencode } from "../../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";
import getTransactions from "../../../controllers/booking/Transactions.js/getTransactions";
import getWalletPayoutRequests from "../../../controllers/settings/wallet/getWalletPayoutRequests";
import useInvoiceApi from "../../../hooks/useInvoiceApi";

function TransactionsTabs({ onTabChange }) {
  const params = URLdecode();
  const { getInvoices } = useInvoiceApi();
  const navigate = useNavigate();
  const location = useLocation();
  const [transactions, setTransactions] = useState(0);
  const [requests, setRequests] = useState(0);
  const [invoices, setInvoices] = useState(0);
  const [loading, setLoading] = useState(false);

  const tabs = [
    {
      label: "Transactions",
      amount: transactions,
      value: "transaction",
    },
    {
      label: "Payout Requests",
      amount: requests,
      value: "payout",
    },
    {
      label: "Invoices",
      amount: invoices,
      value: "invoice",
    },
  ];

  const loadTransacions = async () => {
    const query = {
      limit: 1,
      offset: 0,
      filterBy: "status",
      filterValue: "Success",
    };

    await getTransactions(new URLSearchParams(query)?.toString()).then(
      (res) => {
        const total = res?.data?.meta?.total;
        if (total) {
          setTransactions(total);
        }
      }
    );
  };

  const loadPayouts = async () => {
    const query = {
      limit: 1,
      offset: 0,
    };

    await getWalletPayoutRequests(new URLSearchParams(query)?.toString()).then(
      (res) => {
        const total = res?.data?.meta?.total;
        if (total) {
          setRequests(total);
        }
      }
    );
  };

  const loadInvoices = async () => {
    await getInvoices({
      limit: 1,
      offset: 0,
      noSave: true,
      callback: (data) => {
        setInvoices(data?.data?.meta?.total || 0);
      },
    });
  };

  const loadData = async () => {
    setLoading(true);
    const promises = [loadTransacions(), loadPayouts(), loadInvoices()];
    await Promise.all(promises).finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex w-full gap-4 overflow-x-scroll scroll-hide">
      {tabs.map(({ label, amount, value }) => {
        const isSelected = params?.tab
          ? params.tab === value
          : value === "transaction";

        return (
          <button
            key={value}
            onClick={() => {
              onTabChange(value);
              navigate(
                `${location.pathname}?${URLencode({ ...params, tab: value })}`
              );
            }}
            className={`h-14 flex items-center justify-between gap-2 px-4 font-bold rounded-lg ${
              isSelected
                ? "text-white bg-[#4E5662]"
                : "text-[#818083] bg-[#F8F8F8]"
            }`}
          >
            <span className="text-xs md:text-base">{label}</span>
            {loading ? (
              <div
                className={isSelected ? "buttonLoader" : "primaryLoader"}
              ></div>
            ) : (
              <span
                className={`text-sm px-2 rounded-md py-1 ${
                  isSelected ? "text-[#47A0FA] bg-[#5F6978]" : "bg-[#F1F1F1]"
                }`}
              >
                {amount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default TransactionsTabs;

{
  /* <Tabs value={tab} onChange={(_, val) => setTab(val)}>
        {["Transactions", "Payout Requests", "Invoice"]?.map((obj, i) => (
          <Tab label={<b>{obj}</b>} key={i} />
        ))}
      </Tabs> */
}
